<script setup>

const props = defineProps({
	active: Boolean,
	visible: Boolean,
	color: String,
})

</script>

<template >
	<svg width="23" height="32" viewBox="0 0 23 32" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M4.89035 18.01C4.03035 18.01 3.34033 17.31 3.34033 16.46V9.13997C3.34033 4.59997 7.02034 0.909973 11.5703 0.909973C16.1103 0.909973 19.8003 4.58997 19.8003 9.13997V23.16H16.7003V9.23997C16.7003 6.36997 14.3503 3.96997 11.4903 4.01997C8.71033 4.06997 6.46033 6.34997 6.46033 9.13997V16.46C6.46033 17.32 5.76034 18.01 4.91034 18.01H4.89035Z"
			:fill="`rgb(var(--color-${color}) / 1)`"
		/>
		<path
			d="M19.5702 13.74H3.56018C1.69018 13.74 0.180176 15.25 0.180176 17.12V28.53C0.180176 30.4 1.69018 31.91 3.56018 31.91H19.5702C21.4402 31.91 22.9502 30.4 22.9502 28.53V17.12C22.9502 15.25 21.4402 13.74 19.5702 13.74ZM13.2202 25.23C13.2202 26.06 12.5502 26.73 11.7202 26.73H11.6102C10.7802 26.73 10.1102 26.06 10.1102 25.23V20.43C10.1102 19.6 10.7802 18.93 11.6102 18.93H11.7202C12.5502 18.93 13.2202 19.6 13.2202 20.43V25.23Z"
			:fill="`rgb(var(--color-${color}) / 1)`"
		/>
	</svg>
</template>